// Interface für die aktuellen News
export interface AktuellesNews {
	title: string;
	description: string[];
	url: string;
	slider_url: string;
	slider_pictures: string[];
	image: string;
}

export const aktuellesNews: AktuellesNews[] = [

];
